import React, { useState } from "react";
import { useVapiVariables } from "../../../../../../hooks/useVapiVariables";

export default function UserGuideModal({open,onClose,showModal,type='context'}) {
    const { variables: variableDetails, loading, error } = useVapiVariables(type);
  
   

    const closeModal = () => {
       // setShowModal(false);
       onClose();
    };

    return (
        <>
            {/* Trigger Button */}
           

            {/* Modal */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                       transform: "translate(-50%, -50%)",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 99990072
                    }}
                    onClick={closeModal}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
                            padding: "24px",
                            minWidth: "400px",
                            maxWidth: "600px",
                            maxHeight: "80vh",
                            overflow: "auto",
                            position: "relative"
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Modal Header */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                            <h4 style={{ margin: 0, color: "#333", fontWeight: "600",fontSize:'20px' }}>Variables Guide</h4>
                            <button
                                onClick={closeModal}
                                style={{
                                    background: "none",
                                    border: "none",
                                    fontSize: "24px",
                                    cursor: "pointer",
                                    color: "#666",
                                    padding: "0",
                                    lineHeight: "1"
                                }}
                                title="Close"
                            >
                                &times;
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div>
                            <div style={{ marginBottom: "16px", color: "#555", fontSize: "14px" }}>
                                You can use the following variables in your conversation goal. They will be automatically replaced with real-time values when the conversation runs.
                            </div>
                            
                            {loading ? (
                                <div style={{ textAlign: "center", padding: "20px" }}>
                                    <div style={{ fontSize: "14px", color: "#666" }}>Loading variables...</div>
                                </div>
                            ) : error ? (
                                <div style={{ 
                                    padding: "12px", 
                                    backgroundColor: "#fff3cd", 
                                    border: "1px solid #ffeaa7",
                                    borderRadius: "6px",
                                    marginBottom: "16px"
                                }}>
                                    <div style={{ fontSize: "13px", color: "#856404" }}>
                                        <strong>⚠️ Notice:</strong> Using default variables due to connection issue. {error}
                                    </div>
                                </div>
                            ) : null}
                            
                            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                                {variableDetails.map((item, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            padding: "12px",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "6px",
                                            backgroundColor: "#f8f9fa"
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                                            <code
                                                style={{
                                                    backgroundColor: "#007bff",
                                                    color: "white",
                                                    padding: "2px 6px",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    fontWeight: "600",
                                                    marginRight: "8px"
                                                }}
                                            >
                                                {item.key || item.variable}
                                            </code>
                                            <span style={{ fontWeight: "500", color: "#333" }}>{item.label || item.name || item.text}</span>
                                        </div>
                                        <div style={{ fontSize: "13px", color: "#666", marginLeft: "4px" }}>
                                            {item.description}
                                        </div>
                                    </div>
                                ))}
                            </div>

                          
                        </div>

                        {/* Modal Footer */}
                        <div style={{ marginTop: "20px", textAlign: "right" }}>
                            <button
                                onClick={closeModal}
                                className="linear-gradient yr-submitbtn btn-sm yr-btn-small"
                            >
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
